.main {
    /* Highest will elevate even over call controls */
    z-index: var(--mantine-priority-highest);
}

.inner {
    justify-content: space-between;
    align-items: center;
}

.widgetMain {
    border-bottom: solid 1px var(--mantine-color-dark-4);
    border-radius: 8px 8px 0 0;
    padding: 14px 14px 10px 14px;

    &:hover {
        opacity: 0.8;
        transition: opacity 0.3s ease-out;
        cursor: pointer;
    }
}
